module.exports = __webpack_public_path__ + "img/22t.prt.d4df2991.jpg";